import React from 'react';
import { DragLayer } from 'react-dnd';
import { Identifier, XYCoord } from 'dnd-core';
import { WrappedComponentProps, injectIntl } from 'react-intl';
// Interfaces
import { DragItemTypes, IDragItem } from '../../interfaces/message.interfaces';
// Helpers
import { cn } from '../../helpers/className';
// Assets
import images from '../../assets/images/images';
import styles from './draglayer.module.scss';

export interface ICustomDragLayerProps extends WrappedComponentProps {
    item?: { item?: IDragItem };
    itemType?: Identifier | null;
    initialOffset?: XYCoord | null;
    currentOffset?: XYCoord | null;
    isDragging?: boolean;
    selectedCount: number;
}

class CustomDragLayer extends React.Component<ICustomDragLayerProps> {
    private previewCanvas = React.createRef<HTMLCanvasElement>();

    getItemStyles = (): { display?: string; transform?: string } => {
        const { initialOffset, currentOffset } = this.props;
        if (!initialOffset || !currentOffset) {
            return {
                display: 'none',
            };
        }

        const x = currentOffset.x;
        const y = currentOffset.y;
        const transform = `translate(${x}px, ${y}px)`;
        return {
            transform: transform,
        };
    };

    getCanvasImage = (): void => {
        const canvasContext = this.previewCanvas.current.getContext('2d');
        const image = new Image(24, 16);
        image.src = images.sprite;
        canvasContext.drawImage(image, 0, 813, 24, 16, 0, 4, 24, 16);
    };

    createDragText = (): string => {
        if (this.props.item.item.overBlocked) {
            return this.props.intl.formatMessage({ id: 'DRAG_TO_SEARCH_FOLDER_NOT_POSSIBLE' });
        }

        if (this.props.selectedCount > 1) {
            return this.props.intl.formatMessage({ id: 'DRAG_SEVERAL_MAILS' }, { count: this.props.selectedCount });
        }

        return this.props.intl.formatMessage({ id: 'DRAG_ONE_MAIL' }, { title: this.props.item.item.documentTitle });
    };

    public render(): JSX.Element {
        if (this.previewCanvas.current && this.props.isDragging) {
            this.getCanvasImage();
        }

        return this.props.isDragging ? (
            this.props.itemType === DragItemTypes.MAILITEM ? (
                <div className={styles.dragLayer}>
                    <div className="d-flex row" style={this.getItemStyles()}>
                        <canvas ref={this.previewCanvas} width={30} height={24} />
                        <div
                            className={cn(
                                'd-flex px-2',
                                styles.dragging,
                                this.props.item.item.overBlocked && styles.overBlocked
                            )}
                        >
                            {this.createDragText()}
                        </div>
                    </div>
                </div>
            ) : null
        ) : null;
    }
}

const intlInjected = injectIntl(CustomDragLayer);

export default DragLayer((monitor) => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    initialOffset: monitor.getInitialClientOffset(),
    currentOffset: monitor.getClientOffset(),
    isDragging: monitor.isDragging(),
}))(intlInjected);
